import { useUser } from './useUser';

export type ColorPaletteConfig = 'both' | 'new' | 'old';
export function useColorPalette(now: Date = new Date()): {
  colorPalette: ColorPaletteConfig;
} {
  const user = useUser();

  const isAfterJuly2025 = now >= new Date('2025-07-01');
  if (isAfterJuly2025) {
    return { colorPalette: 'new' };
  }

  const userCreatedAt = user?.createdAt;
  if (!userCreatedAt) {
    return { colorPalette: 'new' };
  }
  const isCreatedBeforeCutoff = userCreatedAt < new Date('2025-05-22');

  return { colorPalette: isCreatedBeforeCutoff ? 'both' : 'new' };
}
